import $ from "jquery";

export const RenderRecaptcha = (target, callback, level = 0) => {
    if (typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render === 'function') {

        if (typeof $(target).data('grecaptcha_id') !== 'undefined') {
            window.grecaptcha.reset($(target).data('grecaptcha_id'));
            return $(target).data('grecaptcha_id') * 1;
        }

        const data = {
            sitekey: application.oss.recaptcha.sitekey,
            hl: $('html').attr('lang')
        };
        if (typeof callback === 'function') {
            data['callback'] = callback;
        }
        const rId = window.grecaptcha.render(target, data);
        $(target).data('grecaptcha_id', rId)
        $(target).attr('data-grecaptcha_id', rId)
        return rId;
    } else if (level < 3) {

        setTimeout(function () {
            RenderRecaptcha(target, callback, level + 1);
        }, 1000)
    }

    return false;
}

export const ShowRecaptchaPopup = (xhr, popupOptions) => {
    if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.required_recaptcha !== 'undefined' && xhr.responseJSON.required_recaptcha === true) {
        let recaptchaWidgetId = '';
        let message = application.oss.translations.oss_form.recaptcha_challenge_message;

        if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.message !== 'undefined' && xhr.responseJSON.message && xhr.responseJSON.message.toString().length) {
            message = `<p>${xhr.responseJSON.message}</p><p>${message}</p>`;
        }
        console.log('xhr', xhr)
        let bootstrapClasses = {
            container: 'container',
            containerFluid: 'container-fluid',
            row: 'row'
        };

        if (typeof popupOptions !== 'undefined' && typeof popupOptions.bootstrapClasses !== 'undefined') {
            bootstrapClasses = popupOptions.bootstrapClasses;
        }

        $.alert({
            title: '',
            bootstrapClasses: bootstrapClasses,
            content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content">
                                                      <div id="confirm-message" class="confirm-div">${message}</div>
                                                      <div id="recaptcha-challenge" class="confirm-div"></div>
</div>
                                                `,
            onContentReady: function () {
                var jc = this;
                jc.buttons.confirm.disable();
                recaptchaWidgetId = RenderRecaptcha(jc.$content.find('#recaptcha-challenge')[0], function (response) {
                    jc.buttons.confirm.enable();
                });

            },
            buttons: {
                confirm: {
                    text: application.oss.translations.oss_form.confirm_recaptcha_challenge,
                    btnClass: 'main-btn',
                    action: function () {
                        var jc = this;
                        const recaptchaValue = window.grecaptcha.getResponse(recaptchaWidgetId);

                        $.ajax({
                            url: application.oss.urls.resolve_recaptcha,
                            dataType: 'json',
                            method: 'post',
                            bootstrapClasses: bootstrapClasses,
                            data: {
                                code: recaptchaValue,
                            },
                            xhrFields: {
                                withCredentials: true
                            },
                            beforeSend: function () {
                                jc.showLoading();
                            },
                            success: (response) => {
                                if (typeof response.status !== 'undefined' && response.status) {
                                    jc.close();
                                    $.alert({
                                        title: '',
                                        bootstrapClasses: bootstrapClasses,
                                        content: `
                                              <div class="check-icon"><i class="icon-checkmark"></i> </div>
                                              <div class="confirm-content"><div class="confirm-div">${application.oss.translations.oss_form.confirm_recaptcha_challenge_passed_message}</div>
                                              `,
                                        buttons: {
                                            close: {
                                                text: application.oss.translations.oss_form.close,
                                                btnClass: 'main-btn',
                                            },
                                        }
                                    })
                                }
                                jc.hideLoading();
                                jc.buttons.confirm.disable();

                            },
                            complete: function () {
                                window.grecaptcha.reset(recaptchaWidgetId);
                                jc.buttons.confirm.disable();
                                jc.hideLoading();
                            },
                            error: (xhr) => {
                                jc.hideLoading();
                                jc.buttons.confirm.disable();
                                jc.$content.find('#confirm-message').html(application.oss.translations.oss_form.confirm_recaptcha_challenge_failed_message);
                                window.grecaptcha.reset(recaptchaWidgetId);
                            }

                        })


                        return false;

                    }
                }
            }
        })
        return true;
    }
    return false;
}
